/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Julia Ignatieva
 * @version 1.13.0
 * @since 1.13.0
 */

import styled from 'styled-components';

import { colors, fonts } from '../../../../../../theme';

export const SubscriberIdAdditionalAccountsStyled = styled.div.attrs({
    className: 'subscriber-id-additional-accounts',
})`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 32px;
    height: 100%;

    .subscriber-id-additional-accounts__block {
      display: flex;
      flex-direction: column;
    }

    .subscriber-id-additional-accounts__title {
      margin-bottom: 24px;
      ${fonts.textMainBold}
    }

    .subscriber-id-additional-accounts__content {
      flex-grow: 1;
      margin-bottom: 32px;

      .subscriber-id-additional-accounts__subtitle {
        margin-bottom: 4px;
        color: ${colors.textColorOpacity};
      }

      .subscriber-id-additional-accounts__text {
        margin-bottom: 16px;
      }
    }
`;
